module.exports = __webpack_public_path__ + "static/assets/3de0dbf1a3747f65a9bcc8a4a4f9a5d3.gif";